import { render, staticRenderFns } from "./Belly.vue?vue&type=template&id=47dd38b7&"
import script from "./Belly.vue?vue&type=script&lang=js&"
export * from "./Belly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports